import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // Only add token for API requests to our backend
  const apiBase = 'dev-app.primasales.de/api';
  if (!req.url.includes(apiBase)) {
    return next(req);
  }

  // Skip token for unauthenticated endpoints (matches http.service.ts line 37 logic)
  const skipPaths = ['/auth/login', '/auth/register', '/auth/sms'];
  const url = req.url;
  if (skipPaths.some((path) => url.includes(path))) {
    return next(req);
  }
  // Exact match for changePassword (not changePasswordVP)
  if (url.endsWith('/auth/changePassword') || url.includes('/auth/changePassword?')) {
    return next(req);
  }

  const token = auth.token;
  if (token) {
    // Do NOT set Content-Type for FormData — browser sets boundary automatically
    const cloned = req.clone({
      setHeaders: { Authorization: token },
    });
    return next(cloned);
  }

  return next(req);
};
